export default class FavouriteModalManager {
    constructor() {
        this.eventDelegation();
    }

    eventDelegation() {
        $('[data-action="closeFavouriteModal"]').click((event) => {
            myApp.customModalManager.closeModal('#removeFavouriteModal');
        })

        $('[data-action="removeFavourite"]').click((event) => {
            const customModal = document.getElementById('removeFavouriteModal');
            const groupId = customModal.getAttribute('group-id');
            if (!groupId) return;
            const group = document.querySelector('[data-action="remove-favourite"][data-group-id="'+ groupId +'"]');
            myApp.user.userWebFavouriteGroupManager.removeFavouriteGroup(group);
            myApp.browserHistoryManager.removeState('#removeFavouriteModal');
        })
    }
}


